import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tw-flex tw-flex-col tw-gap-2 tw-w-full" }

import CoreButton from 'frontcore/components/CoreButton.vue'
import CoreInput from 'frontcore/views/input-text/CoreInput.vue'
import i18n from 'frontcore/i18n'
import UseCredentialsLogin from 'frontcore/domain/authorization/view/UseCredentialsLogin'
import { computed, ref, watch } from 'vue'

type Props = {
  applicationId?: string
  isFetchingUserConfiguration: boolean
}
type Emits = {
  (e: 'error', message: string): void,
  (e: 'loginSuccess'): void,
}

export default /*@__PURE__*/_defineComponent({
  __name: 'AuthorizationCredentials',
  props: {
    applicationId: {},
    isFetchingUserConfiguration: { type: Boolean }
  },
  emits: ["error", "loginSuccess"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const { t } = i18n.global

const username = ref<string>('')
const password = ref<string>('')

const loginUseCase = new UseCredentialsLogin(props.applicationId)
const { error, login } = loginUseCase.use()

const isLoading = ref<boolean>(false)
const loginHandler = async () => {
  isLoading.value = true
  await login(username.value, password.value)
  if (error.value !== null) {
    isLoading.value = false
    emit('error', error.value)
  } else {
    emit('loginSuccess')
  }
}

const isLoginButtonDisabled = computed<boolean>(() => {
  return username.value === '' || password.value === '' || props.isFetchingUserConfiguration
})

const isLoginButtonLoading = computed<boolean>(() => {
  return isLoading.value || (isLoading.value && props.isFetchingUserConfiguration)
})

const resetPassword = () => {
  const url = `${MPS_URL}/reset-password/?continue=${window.location}`
  window.location.assign(url)
}

watch(
  () => props.isFetchingUserConfiguration,
  (newValue, oldValue) => {
    if (newValue || newValue === oldValue) { return }
    isLoading.value = newValue
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    class: "tw-flex tw-flex-col tw-gap-4 tw-items-center",
    onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(CoreInput, {
        value: username.value,
        label: _unref(t)('common.messages.username'),
        placeholder: _unref(t)('common.messages.username'),
        dataTest: "input-username",
        onInput: _cache[0] || (_cache[0] = ($event: any) => (username.value = $event))
      }, null, 8, ["value", "label", "placeholder"]),
      _createVNode(CoreInput, {
        value: password.value,
        label: _unref(t)('common.messages.password'),
        placeholder: _unref(t)('common.messages.password'),
        dataTest: "input-password",
        type: "password",
        onInput: _cache[1] || (_cache[1] = ($event: any) => (password.value = $event))
      }, null, 8, ["value", "label", "placeholder"]),
      _createElementVNode("a", {
        class: _normalizeClass([
          'tw-cursor-pointer body--body-01',
          'tw-text-core-primary-50 tw-decoration-core-primary-50',
          'hover:tw-underline',
          'focus:tw-shadow-sm focus:tw-shadow-core-primary-70',
          'visited:tw-text-extra-purple-30 visited:tw-decoration-extra-purple-30'
        ]),
        "data-test": "password-reset-link",
        onClick: resetPassword
      }, _toDisplayString(_unref(t)('reset_password.messages.forgot_password')), 1)
    ]),
    _createVNode(CoreButton, {
      disabled: isLoginButtonDisabled.value,
      label: _unref(t)('common.messages.sign_in'),
      loading: isLoginButtonLoading.value,
      dataTest: "button-login-ok",
      type: "submit",
      onClick: loginHandler
    }, null, 8, ["disabled", "label", "loading"])
  ], 32))
}
}

})